import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeRepairRequestUpdate } from './serialize';

/**
 * 更新報修單草稿。
 * PATCH `/aftersales/repair-request/{id}`。僅 DRAFT；必含 `updatedAt`。
 * `lines` 若出現＝整表取代；只改 header 時省略。
 *
 * @param {string} id
 * @param {object} payload camelCase
 */
export async function updateRepairRequest(id, payload) {
  const { data: raw } = await request.patch(
    `/aftersales/repair-request/${id}`,
    serializeRepairRequestUpdate(payload),
  );
  return parseVer4DetailResponse(raw);
}
